// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4487d271","885":"ff0ffa1e"}[chunkId] + ".chunk.js";
};